class ProductFormEnhancer {
  constructor(form) {
    this.form = form;
    this.productSection = form.closest('[data-section-id]');
    this.variantInput = form.querySelector('[data-variant-id]');
    this.variantScript = form.querySelector('[data-product-json]');
    if (!this.variantInput || !this.variantScript) return;
    try { this.variants = JSON.parse(this.variantScript.textContent); } catch (e) { return; }
    this.optionInputs = [...form.querySelectorAll('[data-option-position]')];
    this.submitButton = form.querySelector('[type="submit"]');
    this.optionInputs.forEach(input => input.addEventListener('change', () => this.updateVariant()));
  }

  updateVariant() {
    const selected = [];
    this.optionInputs.filter(input => input.checked).forEach(input => {
      selected[Number(input.dataset.optionPosition) - 1] = input.value;
    });
    const variant = this.variants.find(candidate => candidate.options.every((option, index) => option === selected[index]));
    if (!variant) return;
    this.variantInput.value = variant.id;
    if (this.submitButton) {
      this.submitButton.disabled = !variant.available;
      this.submitButton.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-form').forEach(form => new ProductFormEnhancer(form));
});
